import parse from 'html-react-parser';
import { useEffect } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { useGetApiSettingsPublicBySettingTypeKeyQuery } from '../../redux/store/api/api';
import { addMessage } from '../../redux/store/layout/slice';
import Loader from '../loader/Loader';
import { settingTypePrivacyText } from '../../shared/constants';

function PrivacyText(): JSX.Element {
  const dispatch = useAppDispatch();
  const {
    data: privacySetting,
    isFetching,
    isError,
    error,
  } = useGetApiSettingsPublicBySettingTypeKeyQuery({
    settingTypeKey: settingTypePrivacyText,
  });

  useEffect(() => {
    if (isError) {
      dispatch(
        addMessage({
          id: 'GetSettingError',
          variant: 'danger',
          messageKeyBody:
            error && 'data' in error ? error.data?.messageKey : 'unknownError',
        }),
      );
    }
  }, [isError]);

  return (
    <>
      {isFetching && <Loader />}
      {!isFetching && privacySetting?.resultObject?.value && (
        <>{parse(privacySetting.resultObject.value || '')}</>
      )}
    </>
  );
}

export default PrivacyText;
